import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import UpgradeCard from "@/components/trial/UpgradeCard";
import { Compass, LogOut } from "lucide-react";
import { ASSETS } from "@/lib/assets";

export default function TrialEnded() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate("/", { replace: true }); };
  return (
    <div className="min-h-screen" data-testid="trial-ended-page">
      <header className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <img src={ASSETS.logo} alt="HorizonQuest" className="w-10 h-10 rounded-lg object-cover ring-1 ring-primary/40" />
          <span className="font-display text-3xl tracking-tight">HorizonQuest</span>
        </div>
        <button data-testid="trial-ended-logout" onClick={handleLogout} className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/15 text-sm hover:bg-white/5 transition-colors">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 pb-20">
        <div className="text-center py-10 hq-fade-up">
          <Compass className="w-10 h-10 text-primary mx-auto mb-4" />
          <h1 className="font-display text-4xl sm:text-5xl tracking-tight">Your free trial has ended</h1>
          <p className="text-slate-300 mt-3 max-w-xl mx-auto">Thanks for exploring HorizonQuest, {(user?.name || "Guide").split(" ")[0]}. Your classes and progress are saved — reach out and we'll unlock the full voyage for you and your Explorers.</p>
        </div>
        <UpgradeCard user={user} title="Keep sailing with the full HorizonQuest" />
      </main>
    </div>
  );
}
